<template>
  <v-select
    v-model="scoreMin"
    :items="page.scores"
    label="Score min."
    outlined
    hide-details
    :clearable="clearable"
  />
</template>

<script>
import { computed, onMounted, reactive, set } from "@vue/composition-api";
import isEqual from "lodash/isEqual";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

export default {
  name: "ScoreFilter",
  components: {},
  props: {
    initialValue: {
      type: Number,
      default: undefined,
      validator(value) {
        return value == null || !isNaN(value);
      },
    },
    store: {
      type: String,
      validator(value) {
        /* List of stores having :
        - getters["<store>/<storeGetter>"]
        - dispatch("<store>/<storeUpdater>", payload)
        */
        return ["aiFactory", "newsRadar"].includes(value);
      },
    },
    storeGetter: {
      type: String,
      default: "getScoreMin",
    },
    storeUpdater: {
      type: String,
      default: "updateScoreMin",
    },
    noUrl: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
      initialUrlValue: 0, // in case we need to load from url params
      scores: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    });

    // =>  METHODS

    // =>  COMPUTED
    const viaStore = computed(() => props.store !== undefined);
    const initialValue = computed(() =>
      props.noUrl
        ? props.initialValue
        : page.initialUrlValue ?? props.initialValue
    );

    const scoreMin = computed({
      get: () => {
        if (viaStore.value) {
          return store.getters[`${props.store}/${props.storeGetter}`];
        }

        return initialValue.value;
      },
      set: (value) => {
        if (viaStore.value) {
          store.dispatch(`${props.store}/${props.storeUpdater}`, value);

          if (page.isInitialized && !props.noUrl) {
            // Only update user changes, not initialization
            addQueryStringParam({
              param: "scoreMin",
              value: value,
              // is_multiple: false,
              is_integer: true,
              // is_boolean: false,
            });
          }
        }

        if (!isEqual(value, initialValue.value)) {
          emit("valueChanged", value);
        }
      },
    });

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      if (viaStore.value && !props.noUrl) {
        set(
          page,
          "initialUrlValue",
          await synchronizeFilterWithQueryString({
            dispatcher: `${props.store}/updateScoreMin`,
            param: "scoreMin",
            value: scoreMin.value,
            // is_multiple: false,
            is_integer: true,
            // is_boolean: false,
            // dependsOn: undefined,
          })
        );
      }

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      page,
      scoreMin,
    };
  },
};
</script>

<style></style>
